import { openBlock as e, createElementBlock as c, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, t = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M3.783 2.25c-.845 0-1.533.688-1.533 1.533v10.956c0 .845.688 1.533 1.533 1.533h6.015L5.601 20.47a.75.75 0 1 0 1.06 1.06l4.198-4.198V21a.75.75 0 0 0 1.5 0v-3.667l4.198 4.197a.75.75 0 1 0 1.06-1.06l-4.197-4.198h6.797c.845 0 1.533-.688 1.533-1.533V3.783c0-.845-.688-1.533-1.533-1.533H3.783Zm7.834 12.522h8.6l.011-.002a.037.037 0 0 0 .012-.008.037.037 0 0 0 .008-.012l.001-.005v-.002l.001-.004V6.88H3.75v7.86c0 .004 0 .007.002.01a.037.037 0 0 0 .008.011.038.038 0 0 0 .012.009.025.025 0 0 0 .01.002h7.835Zm-7.865-11a.026.026 0 0 0-.002.01V5.38h16.5V3.783c0-.005 0-.008-.002-.011a.038.038 0 0 0-.008-.012.038.038 0 0 0-.012-.008.025.025 0 0 0-.01-.002H3.782c-.005 0-.008 0-.011.002a.038.038 0 0 0-.012.008.038.038 0 0 0-.008.012Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  t
];
function a(r, d) {
  return e(), c("svg", o, [...n]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
